import React from 'react'

export const Spinner = () => {
  return (
        <span class="loader"></span>
  )
}
